import { PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { ProcuracaoItem, ProcuracaoListagemQuery } from "../../typings/procuracao";

function useProcuracoes({
  idAssembleia,
  page,
  limit,
  search,
  status,
}: ProcuracaoListagemQuery) {
  const key = `/v1/votacao/${idAssembleia}/procuracao-${page}-${limit}-${search}-${status}`;

  return useQuery([key], async () => {
    const res = await axios.get<PaginateResult<ProcuracaoItem>>(
      `/v1/votacao/${idAssembleia}/procuracao`,
      {
        params: {
          page,
          limit,
          search,
          status,
        },
      }
    );

    return res.data;
  });
}

export default useProcuracoes;
